import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EDeleteNewbuildingFavoriteActionTypes {
  Success = 'DELETE_NEWBUILDING_FAVORITE/SUCCESS',
}

interface IPayload {
  newbuildingId: number;
}

type TDeleteNewbuildingFavoriteSuccess = ITypedReduxAction<EDeleteNewbuildingFavoriteActionTypes.Success, IPayload>;

export type TDeleteNewbuildingFavorite = TDeleteNewbuildingFavoriteSuccess;

export const deleteNewbuildingFavoriteSuccess = actionGenerator<
  EDeleteNewbuildingFavoriteActionTypes.Success,
  IPayload
>(EDeleteNewbuildingFavoriteActionTypes.Success);
